import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";
import Container from "@mui/material/Container";
import SideBarStore from "./SideBarStore";
import ProductStore from "./ProductStore";
import { useSelector } from "react-redux";
import { checkScreenLaptop, showMainPageStore } from "../../../utils/helpers";
import MainPage from "./MainPage/MainPage";
import { Helmet } from "react-helmet";

export default function Store() {
  const {
    search_term,
    CategorySelected,
    isLoading,
    attributesAvailable,
    categoriesAvailable,
  } = useSelector((state) => state.store);
  const { screenWidth, mediumWidthScreen } = useSelector(
    (state) => state.global
  );

  // signal to Prerender.io when the store data is ready
  useEffect(() => {
    if (
      !isLoading &&
      categoriesAvailable &&
      attributesAvailable &&
      typeof window !== "undefined"
    ) {
      window.prerenderReady = true;
    }
  }, [isLoading, categoriesAvailable, attributesAvailable]);

  return (
    <>
      <Helmet>
        <title>Shop • Deliverit UAE</title>
        <meta
          name="description"
          content="Deliverit UAE - Browse the latest deals, new arrivals, and best-rated products."
        />
        <link rel="canonical" href="https://shop.deliverit.ae/" />
        <meta name="robots" content="index,follow" />
        <meta
          name="keywords"
          content="Deliverit, UAE, online shopping, deals, new arrivals, best rated products"
        />
        <meta property="og:title" content="Shop • Deliverit UAE" />
        <meta
          property="og:description"
          content="Deliverit UAE - Browse the latest deals, new arrivals, and best-rated products."
        />
        <meta property="og:url" content="https://shop.deliverit.ae/" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://shop.deliverit.ae/logo-header.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Shop • Deliverit UAE" />
        <meta
          name="twitter:description"
          content="Deliverit UAE - Browse the latest deals, new arrivals, and best-rated products."
        />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Deliverit",
            url: window.location.origin,
          })}
        </script>
      </Helmet>

      <Box>
        <Container className="no-padding  page_size"> 
          <Box>
              <MainPage />
            </Box>
        </Container>
        {/* <Container className="no-padding  page_size">
          {showMainPageStore(CategorySelected, search_term) ? (
            <Box>
              <MainPage />
            </Box>
          ) : (
            <Grid container>
              {checkScreenLaptop(screenWidth, mediumWidthScreen) ? (
                <>
                  <Grid size={{ lg: 2, md: 4, sm: 4, xs: 6 }}>
                    <SideBarStore
                      className="store_sidebar"
                      isLoading={isLoading}
                      attributesAvailable={attributesAvailable}
                      categoriesAvailable={categoriesAvailable}
                    />
                  </Grid>
                  <Grid size={{ lg: 10, md: 8, sm: 8, xs: 6 }}>
                    <ProductStore />
                  </Grid>
                </>
              ) : (
                <Grid size={{ lg: 12, md: 12, sm: 12, xs: 12 }}>
                  <ProductStore />
                </Grid>
              )}
            </Grid>
          )}
        </Container> */}
      </Box>
    </>
  );
}